export const companyInfo = {
  name: "AM Scrap Dealers",
  tagline: "Authorized Scrap Buyers in Chennai",
  phone: "+91 6374966893",
  whatsapp: "916374966893",
  email: "86123stephen@gmail.com",
  address: "No. 12, Industrial Estate, Taramani, Chennai, Tamil Nadu 600113",
  mapEmbedUrl:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.747!2d80.2278!3d12.9862!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTLCsDU5JzEwLjMiTiA4MMKwMTMnNDAuMSJF!5e0!3m2!1sen!2sin!4v1",
};

export const navLinks = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#why-choose" },
  { label: "Materials", href: "#materials" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "Compliance", href: "#compliance" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "Contact", href: "#contact" },
];

export const heroData = {
  headline: "Authorized Scrap Buyers in Chennai",
  headlineAccent: "Turn Your Scrap Into Instant Value",
  subtext:
    "We help industries and corporates safely sell scrap with transparent pricing, quick pickup & instant payment.",
  trustBadges: [
    { icon: "ShieldCheck", label: "Government Authorized" },
    { icon: "Building2", label: "Corporate Trusted" },
    { icon: "Timer", label: "On-Time Pickup" },
  ],
  heroImage:
    "https://images.unsplash.com/photo-1722695510527-cc033e43be1b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxzY3JhcCUyMG1ldGFsfGVufDB8fHx8MTc3MDk3ODQ1Mnww&ixlib=rb-4.1.0&q=85",
};

export const aboutData = {
  title: "About AM Scrap Dealers",
  subtitle: "Chennai's Trusted Industrial Scrap Partner Since 2010",
  description:
    "Based in Taramani, Chennai, AM Scrap Dealers has been at the forefront of professional scrap management for over a decade. We serve industries across Tamil Nadu with ethical, compliant, and transparent recycling services.",
  highlights: [
    "Based in Taramani, Chennai",
    "Serving industries across Tamil Nadu",
    "Professional scrap management",
    "Ethical & compliant recycling",
    "15+ years of experience",
  ],
  image:
    "https://images.unsplash.com/photo-1617303331806-3d6b58e03241?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxzY3JhcCUyMG1ldGFsfGVufDB8fHx8MTc3MDk3ODQ1Mnww&ixlib=rb-4.1.0&q=85",
};

export const whyChooseData = [
  {
    icon: "ShieldCheck",
    title: "Government Authorized Dealer",
    description:
      "Fully licensed and compliant with all government regulations for scrap collection and recycling.",
  },
  {
    icon: "Scale",
    title: "Transparent Digital Weighing",
    description:
      "State-of-the-art digital weighing systems ensure 100% transparency in every transaction.",
  },
  {
    icon: "TrendingUp",
    title: "Best Market Price",
    description:
      "We offer competitive rates based on real-time market prices, ensuring maximum value for your scrap.",
  },
  {
    icon: "Truck",
    title: "Same-Day Pickup",
    description:
      "Request a pickup and our fleet arrives the same day. No waiting, no delays.",
  },
  {
    icon: "Banknote",
    title: "Instant Online Payment",
    description:
      "Receive payment instantly via bank transfer, UPI, or cheque. No payment delays.",
  },
  {
    icon: "Headphones",
    title: "Dedicated Support Team",
    description:
      "A dedicated relationship manager assigned to your account for seamless communication.",
  },
];

export const materialsData = [
  {
    icon: "Wrench",
    name: "Iron & Steel",
    description: "All forms of ferrous metal scrap including beams, sheets, and structural steel.",
  },
  {
    icon: "Zap",
    name: "Copper",
    description: "Copper wiring, pipes, fittings, and other copper-based materials.",
  },
  {
    icon: "Container",
    name: "Aluminum",
    description: "Aluminum sheets, profiles, cans, and industrial aluminum scrap.",
  },
  {
    icon: "Monitor",
    name: "E-Waste",
    description: "Computers, electronics, circuit boards, and electronic components.",
  },
  {
    icon: "Recycle",
    name: "Plastic",
    description: "Industrial plastic waste, PVC, HDPE, and other recyclable plastics.",
  },
  {
    icon: "FileText",
    name: "Paper",
    description: "Office paper, cardboard, newspapers, and packaging materials.",
  },
  {
    icon: "Cog",
    name: "Machinery Scrap",
    description: "Old machinery, equipment parts, and industrial machine components.",
  },
  {
    icon: "Briefcase",
    name: "Office Scrap",
    description: "Furniture, fixtures, IT equipment, and general office disposals.",
  },
];

export const industriesData = [
  { icon: "Factory", name: "Manufacturing Plants" },
  { icon: "Building2", name: "IT Parks" },
  { icon: "Warehouse", name: "Warehouses" },
  { icon: "HardHat", name: "Construction Sites" },
  { icon: "Heart", name: "Hospitals" },
  { icon: "Landmark", name: "Corporates" },
  { icon: "ShoppingCart", name: "Retail Chains" },
  { icon: "GraduationCap", name: "Educational Institutions" },
];

export const howItWorksData = [
  {
    step: 1,
    title: "Contact Us",
    description: "Reach out via phone, WhatsApp, or our online form. Tell us about your scrap.",
    icon: "MessageSquare",
  },
  {
    step: 2,
    title: "Inspection & Quote",
    description: "Our team visits your location, inspects the scrap, and provides a transparent price quote.",
    icon: "ClipboardCheck",
  },
  {
    step: 3,
    title: "Pickup from Location",
    description: "We arrange pickup with our fleet. Loading and transportation handled by our trained crew.",
    icon: "Truck",
  },
  {
    step: 4,
    title: "Instant Payment",
    description: "Receive payment immediately via bank transfer, UPI, or cheque upon completion.",
    icon: "BadgeCheck",
  },
];

export const complianceData = {
  title: "Government Authorization & Compliance",
  subtitle:
    "We operate under full government authorization with all required licenses and certifications.",
  items: [
    {
      icon: "FileCheck",
      title: "Trade License",
      description: "Registered under Chennai Corporation with a valid trade license for scrap dealing.",
    },
    {
      icon: "Award",
      title: "Pollution Control Board",
      description: "Certified by Tamil Nadu Pollution Control Board for eco-friendly recycling practices.",
    },
    {
      icon: "Shield",
      title: "GST Registered",
      description: "Fully GST compliant with proper invoicing and documentation for every transaction.",
    },
    {
      icon: "Leaf",
      title: "Eco-Friendly Recycling",
      description: "All materials recycled through environmentally responsible processes and facilities.",
    },
    {
      icon: "Scale",
      title: "Legal Disposal",
      description: "Complete adherence to legal disposal practices for hazardous and non-hazardous waste.",
    },
    {
      icon: "BadgeCheck",
      title: "ISO Certified",
      description: "Following ISO standards for quality management in scrap processing and recycling.",
    },
  ],
  image:
    "https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHxzdXN0YWluYWJpbGl0eXxlbnwwfHx8fDE3NzA5Nzg0NTd8MA&ixlib=rb-4.1.0&q=85",
};

export const testimonialsData = [
  {
    name: "Rajesh Kumar",
    role: "Factory Manager",
    company: "Titan Industries Pvt Ltd",
    rating: 5,
    review:
      "AM Scrap Dealers has been our trusted partner for 3 years. Their transparent weighing and instant payment system make the entire process smooth. Highly recommend for any manufacturing unit.",
  },
  {
    name: "Priya Venkatesh",
    role: "Warehouse Head",
    company: "GlobalTech Logistics",
    rating: 5,
    review:
      "The professionalism AM Scrap Dealers brings to scrap management is unmatched. Same-day pickup and competitive pricing have saved us both time and money.",
  },
  {
    name: "Anand Sharma",
    role: "Admin Manager",
    company: "Infosys Technologies",
    rating: 5,
    review:
      "As a corporate office, we needed a reliable partner for e-waste disposal. AM Scrap Dealers handled everything from pickup to documentation. 100% compliant and hassle-free.",
  },
  {
    name: "Meera Sundaram",
    role: "Operations Director",
    company: "TVS Supply Chain",
    rating: 4,
    review:
      "We've been working with AM Scrap Dealers across our warehouses in Tamil Nadu. Their dedicated support team and consistent pricing have made them our go-to scrap partner.",
  },
];

export const statsData = [
  { value: "1000+", label: "Pickups Completed" },
  { value: "500+", label: "Businesses Served" },
  { value: "24hr", label: "Service Turnaround" },
  { value: "100%", label: "Legal Compliance" },
];
